export const DarkBlue = ({
  className,
  accent1,
}: {
  className?: string;
  accent1?: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="362"
    viewBox="0 0 32 362"
    fill="none"
  >
    <g clipPath="url(#clip0_3736_5239)">
      <rect width="32" height="362" fill={accent1} />
      <path d="M0 330L-1.57361e-06 362L34 362" fill="white" />
      <path d="M32 330L32 362L-2 362" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_3736_5239">
        <rect width="32" height="362" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
